<template>
  <component
    :is="tag"
    class="skeleton"
    :class="{ 'skeleton--colorless': colorless }"
  >
    <div
      data-grid="column"
      class="skeleton__wrapper grid--va-center grid--center"
    >
      <slot />
    </div>
  </component>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Skeleton',

  props: {
    colorless: Boolean,

    tag: {
      type: String,
      default: () => 'div'
    }
  }
})
</script>

<style lang="scss">
  .skeleton {
    &--colorless,
    .is-dark-theme &--colorless {
      animation: initial !important;
    }
  }
</style>
